module.exports = __webpack_public_path__ + "static/media/patient-department-icon.66590a09.svg";